import React from 'react';
import Skeleton from '../common/skeleton';
import Header from '../../components/common/Header/Header';

const RegistrationSetupSkeleton = () => (
  <div className="claims-details container-fluid p-0">
    <Header
      linkTo={'/admin/admin-dashboard'}
      header={'Configure Registration'}
    />
    <form className="border-right-after">
      <div className="Payment-details member-and-dependent row">
        <div className="pl-0 col">
          <h3 className="mb-4">
            <Skeleton count={1} width={255} containerClassName={'form-label'} />
          </h3>
          <p className="d-flex flex-column">
            <Skeleton
              count={1}
              width={385}
              height={16}
              containerClassName={'form-label mb-2'}
            />
            <Skeleton
              count={1}
              width={305}
              height={16}
              containerClassName={'form-label'}
            />
          </p>
        </div>
        <div className="setup-form col">
          <div id="formGridallowMember" className="form-group d-flex">
            <div className="form-check ">
              <Skeleton
                count={1}
                width={20}
                height={20}
                containerClassName={'form-label'}
              />
            </div>
            <div className="d-flex flex-column ml-3">
              <Skeleton
                count={1}
                width={185}
                height={18}
                containerClassName={'form-label mb-2'}
              />
              <Skeleton
                count={1}
                width={385}
                height={18}
                containerClassName={'form-label'}
              />
            </div>
          </div>
          <div id="formGridallowDependent" className="form-group d-flex">
            <div className="form-check ">
              <Skeleton
                count={1}
                width={20}
                height={20}
                containerClassName={'form-label'}
              />
            </div>
            <div className="d-flex flex-column ml-3">
              <Skeleton
                count={1}
                width={185}
                height={18}
                containerClassName={'form-label mb-2'}
              />
              <Skeleton
                count={1}
                width={385}
                height={18}
                containerClassName={'form-label'}
              />
            </div>
          </div>
          <div className="form-group d-flex flex-column">
            <Skeleton
              count={1}
              width={185}
              height={18}
              containerClassName={'form-label mb-1'}
            />
            <Skeleton count={1} height={38} containerClassName={'form-label'} />
          </div>
        </div>
      </div>
      <div className="Payment-details member-and-dependent row">
        <div className="pl-0 col">
          <h3 className="mb-4">
            <Skeleton count={1} width={255} containerClassName={'form-label'} />
          </h3>
          <p className="d-flex flex-column">
            <Skeleton
              count={1}
              width={385}
              height={16}
              containerClassName={'form-label mb-2'}
            />
            <Skeleton
              count={1}
              width={305}
              height={16}
              containerClassName={'form-label'}
            />
          </p>
        </div>
        <div className="setup-form col">
          <div id="formGridallowMember" className="form-group d-flex">
            <div className="form-check ">
              <Skeleton
                count={1}
                width={20}
                height={20}
                containerClassName={'form-label'}
              />
            </div>
            <div className="d-flex flex-column ml-3">
              <Skeleton
                count={1}
                width={185}
                height={18}
                containerClassName={'form-label mb-2'}
              />
              <Skeleton
                count={1}
                width={385}
                height={18}
                containerClassName={'form-label'}
              />
            </div>
          </div>
          <div id="formGridallowDependent" className="form-group d-flex">
            <div className="form-check ">
              <Skeleton
                count={1}
                width={20}
                height={20}
                containerClassName={'form-label'}
              />
            </div>
            <div className="d-flex flex-column ml-3">
              <Skeleton
                count={1}
                width={185}
                height={18}
                containerClassName={'form-label mb-2'}
              />
              <Skeleton
                count={1}
                width={385}
                height={18}
                containerClassName={'form-label'}
              />
            </div>
          </div>
          <div className="form-group d-flex flex-column">
            <Skeleton
              count={1}
              width={185}
              height={18}
              containerClassName={'form-label mb-1'}
            />
            <Skeleton count={1} height={38} containerClassName={'form-label'} />
          </div>
        </div>
      </div>
      <div className="Payment-details member-and-dependent row">
        <div className="pl-0 col">
          <h3 className="mb-4">
            <Skeleton count={1} width={255} containerClassName={'form-label'} />
          </h3>
          <p className="d-flex flex-column">
            <Skeleton
              count={1}
              width={385}
              height={16}
              containerClassName={'form-label mb-2'}
            />
            <Skeleton
              count={1}
              width={305}
              height={16}
              containerClassName={'form-label'}
            />
          </p>
        </div>
        <div className="setup-form col">
          <div id="formGridallowMember" className="form-group d-flex">
            <div className="form-check ">
              <Skeleton
                count={1}
                width={20}
                height={20}
                containerClassName={'form-label'}
              />
            </div>
            <div className="d-flex flex-column ml-3">
              <Skeleton
                count={1}
                width={185}
                height={18}
                containerClassName={'form-label mb-2'}
              />
              <Skeleton
                count={1}
                width={385}
                height={18}
                containerClassName={'form-label'}
              />
            </div>
          </div>
          <div id="formGridallowDependent" className="form-group d-flex">
            <div className="form-check ">
              <Skeleton
                count={1}
                width={20}
                height={20}
                containerClassName={'form-label'}
              />
            </div>
            <div className="d-flex flex-column ml-3">
              <Skeleton
                count={1}
                width={185}
                height={18}
                containerClassName={'form-label mb-2'}
              />
              <Skeleton
                count={1}
                width={385}
                height={18}
                containerClassName={'form-label'}
              />
            </div>
          </div>
          <div className="form-group d-flex flex-column">
            <Skeleton
              count={1}
              width={185}
              height={18}
              containerClassName={'form-label mb-1'}
            />
            <Skeleton count={1} height={38} containerClassName={'form-label'} />
          </div>
        </div>
      </div>
    </form>
  </div>
);

export default RegistrationSetupSkeleton;
